module.exports = __webpack_public_path__ + "static/media/pillow-hopping.39b548c4.jpg";